import { parseHtmlString } from "@/utils/helpers/html";
import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";


const OurGoals = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex flex-col gap-2">
        <Paragraph className=" py-1 px-3 flex items-center justify-center !text-sm bg-wine-200 w-fit rounded-2xl text-white">Our Goal</Paragraph>

        <div className="flex items-center gap-6 text-white">
          <Heading level={4} >{data.title ?? "Default Title"}</Heading>
        </div>
        <Paragraph className="text-white" dangerouslySetInnerHTML={parseHtmlString(data.description ?? "Default Description")} />
      </div>
    </EditableSection>
  )
}

export default OurGoals